"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _headlineLockup = require("@site/pattern-library-core/headline-lockup");
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
var _list = _interopRequireDefault(require("@site/pattern-library-core/list"));
var _index = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _price = _interopRequireDefault(require("@site/pattern-library-core/price"));
var _image = require("@site/pattern-library-core/image");
var _merchButton = require("@site/pattern-library-core/merch-button");
var _tracking = require("@site/pattern-library-utils/tracking");
/* eslint-disable complexity */

/**
 * Local Imports
 */

const Flag = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Flag",
  class: "pl-f4hbr3y",
  vars: {
    "f4hbr3y-0": [({
      partial
    }) => partial ? `${_intents.default.ux.feedback.onFeedbackColor}` : `${_intents.default.ux.box.foregroundColor}`]
  }
});
const ImageWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageWrapper",
  class: "pl-i15sislj"
});
const PlanBox = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PlanBox",
  class: "pl-ppgth0w",
  vars: {
    "ppgth0w-0": [({
      featureColor
    }) => featureColor],
    "ppgth0w-3": [({
      featured
    }) => featured ? 'var(--border-featured)' : `var(--border-default)`],
    "ppgth0w-6": [({
      col
    }) => col]
  }
});
const PlanName = /*#__PURE__*/(0, _react2.styled)(_headlineLockup.HeadlineString)({
  name: "PlanName",
  class: "pl-ppgghqt"
});
const PlanTagContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PlanTagContainer",
  class: "pl-p31gjll"
});
const descriptionStyles = "pl-d1ud9xbx";
const CTAContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CTAContainer",
  class: "pl-ckez7l7"
});
const Item = /*#__PURE__*/(0, _react2.styled)(_paragraph.default)({
  name: "Item",
  class: "pl-i2hujp2"
});
const CrossLinkContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CrossLinkContainer",
  class: "pl-c1stbry9"
});
const PlanBoxList = /*#__PURE__*/(0, _react2.styled)(_list.default)({
  name: "PlanBoxList",
  class: "pl-p1oz5326"
});

/**
 * SimplePlanBox Component.
 * @module SimplePlanBox
 * @param {Object} props React props
 * @param {String} props.id The id of the content item
 * @param {Number} props.col Grid column
 * @param {Boolean} props.flag Flag Active State
 * @param {String} props.flagText Flag Text
 * @param {Object} props.featureColor Featured item highlight color content item
 * @param {Object} props.iconColor RTBList icon color content item
 * @param {String} props.planTagText As low as Top Text
 * @param {String} props.planType PlanType Headline
 * @param {String} props.description Plan Description
 * @param {Object} props.cta Plan Button
 * @param {Object} props.ctaOverrides Cta content item that overrides styling
 * @param {Object} props.featuresList Plan Compare Items Object
 * @param {Object} props.crossLink Cross Link Button Object
 * @param {String} props.crossLinkDisclaimer Cross Link Disclaimer
 * @param {Object} props.featuresListTitle Features List Title
 * @param {Object} props.featuresList Plan Compare Items Object
 * @returns {React.ReactElement} SimplePlanBox Component
 * @public
 */
function SimplePlanBox({
  id,
  col,
  flagText,
  planTagText,
  planType,
  description,
  cta = {},
  ctaType,
  ctaSecondary,
  ctaTypeSecondary,
  ctaOverrides,
  featuresList,
  crossLink,
  crossLinkDisclaimer,
  showImageWrapper = true,
  image,
  price,
  featureColor = {
    intent: 'ux.feedback.feedbackColor'
  },
  iconColor = {
    intent: 'ux.box.foregroundColor'
  },
  featuresListTitle,
  partial
}) {
  const maxRtbs = 25;
  const ctaTemplate = ctaType || cta?.templateName;
  const ctaTemplateSecondary = ctaTypeSecondary || ctaSecondary?.templateName;
  const ctas = [{
    ...cta,
    ...ctaOverrides,
    templateName: ctaTemplate,
    id: cta?.id
  }];
  ctaSecondary && ctas.push({
    ...ctaSecondary,
    ...ctaOverrides,
    templateName: ctaTemplateSecondary,
    id: ctaSecondary?.id
  });
  const isFeatured = !!flagText;
  const useFeatureColor = isFeatured && !partial;
  const textType = partial ? 'title' : 'paragraph';
  const {
    ctaRef
  } = (0, _tracking.useTrackingUpdate)(cta);
  return /*#__PURE__*/_react.default.createElement(PlanBox, (0, _extends2.default)({
    id: `id-${id}`,
    col: col || 0,
    "data-cy": "simple-plan-box",
    featured: isFeatured,
    featureColor: useFeatureColor ? (0, _patternLibraryUtils.getBackgroundColor)(featureColor) : _intents.default.ux.feedback.feedbackColor
  }, partial ? {
    'data-partial': partial
  } : {}), flagText && /*#__PURE__*/_react.default.createElement(Flag, {
    "data-cy": "flag",
    partial: partial
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: textType,
    size: -1,
    text: flagText,
    className: "text-uppercase"
  })), /*#__PURE__*/_react.default.createElement(ImageWrapper, null, showImageWrapper && image?.url && /*#__PURE__*/_react.default.createElement(_image.LazyPicture, {
    defaultSrc: image.url,
    defaultAltText: image?.altText,
    width: image?.width,
    height: image?.height
  })), /*#__PURE__*/_react.default.createElement(PlanName, {
    heading: planType,
    headlineTag: "h3",
    headlineSize: "h6",
    headlineLineLength: 3.0
  }), /*#__PURE__*/_react.default.createElement(PlanTagContainer, null, planTagText && /*#__PURE__*/_react.default.createElement(_tag.default, {
    text: planTagText,
    design: "passive"
  })), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    "data-cy": "paragraph",
    as: "paragraph",
    text: description,
    className: descriptionStyles
  }), price && /*#__PURE__*/_react.default.createElement(_price.default, (0, _extends2.default)({}, price, {
    headlineSize: "h3"
  })), cta && /*#__PURE__*/_react.default.createElement(CTAContainer, {
    "data-cy": "simple-planbox-cta",
    className: "cta",
    ref: ctaRef
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: ctas
  })), featuresList?.features && /*#__PURE__*/_react.default.createElement(PlanBoxList, {
    iconColor: (0, _patternLibraryUtils.getBackgroundColor)(iconColor),
    listTitle: featuresListTitle,
    items: featuresList.features.slice(0, maxRtbs).map(({
      content: txt,
      tooltipItem,
      iconType,
      ...rest
    }) => ({
      ...rest,
      content: /*#__PURE__*/_react.default.createElement(Item, {
        tag: "span",
        text: txt,
        tooltip: tooltipItem
      }),
      iconType: iconType
    }))
  }), /*#__PURE__*/_react.default.createElement(CrossLinkContainer, {
    "data-cy": "cross-links"
  }, (crossLink || crossLinkDisclaimer) && /*#__PURE__*/_react.default.createElement("div", null, crossLink && /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButtonSet, {
    buttons: [{
      ...crossLink,
      width: 'full',
      templateName: 'Link',
      design: 'inline'
    }]
  }), crossLinkDisclaimer && /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    "data-cy": "cross-link-disclaimer",
    text: crossLinkDisclaimer,
    className: "disclaimer"
  }))));
}
var _default = exports.default = SimplePlanBox;
const colorPropTypes = _propTypes.default.oneOfType([_propTypes.default.shape({
  rgb: _propTypes.default.string,
  contrastRgb: _propTypes.default.string
}), _propTypes.default.shape({
  intent: _propTypes.default.string
})]);
const supportedCTATypes = ['addToCart', 'RacModal', 'Button Component', 'HeaderCartButton', 'LeadGenModalButton'];
SimplePlanBox.propTypes = {
  id: _propTypes.default.string,
  col: _propTypes.default.number,
  flagText: _propTypes.default.string,
  featureColor: colorPropTypes,
  iconColor: colorPropTypes,
  planTagText: _propTypes.default.string,
  planType: _propTypes.default.string,
  description: _propTypes.default.string,
  cta: _propTypes.default.object,
  ctaType: _propTypes.default.oneOf(supportedCTATypes),
  ctaSecondary: _propTypes.default.object,
  ctaTypeSecondary: _propTypes.default.oneOf(supportedCTATypes),
  ctaOverrides: _propTypes.default.object,
  featuresListTitle: _propTypes.default.string,
  featuresList: _propTypes.default.shape({
    features: _propTypes.default.array,
    iconColor: _propTypes.default.string
  }),
  crossLink: _propTypes.default.object,
  crossLinkDisclaimer: _propTypes.default.string,
  showImageWrapper: _propTypes.default.bool,
  image: _propTypes.default.object,
  price: _propTypes.default.shape(_price.default.propTypes),
  partial: _propTypes.default.string
};